import RouteNames from "@/plugins/routeNames";

const BodyController = {
  data() {
    return {
      bodyController: {
        components: ["LayoutDefaultMain"],
      },
      mainContainer: "#default-layout-container",
      supportedRoutes: [
        RouteNames.PLAN_LIST,
        RouteNames.QUOTE_RESULT,
        RouteNames.QUOTE_RESULT_PATHS,
        RouteNames.CATEGORY_LANDING,
      ],
    };
  },
  props: {
    triggerAdjustActive: { type: Boolean, default: true },
  },
  mounted() {
    if (
      !global.isClientSide ||
      !this.bodyController.components.includes(this.$options.name)
    )
      return false;

    this.registerBodyResizeListener();
    this.$nextTick(() => {
      this.adjustBody();
    });
  },
  updated() {
    this.adjustBody();
  },
  watch: {
    $route: {
      handler: function (r) {
        this.resetSubHeaderMarginMultiplier();
      },
    },
  },
  methods: {
    // NOTE: call this method when any component causes <header> tag
    // to adjust height that is not caught by mounted() -> $nextTick()
    // like SubHeaderMixin scroll event
    adjustBody() {
      if (!global.isClientSide) return false;

      setTimeout(() => {
        this.triggerAdjust();
      }, 250);
    },
    detachBodyResizeListener() {
      this.$(window).off(`resize.${this.$options.name}`);
    },
    registerBodyResizeListener() {
      this.$(window).on(`resize.${this.$options.name}`, this.triggerAdjust);
    },
    triggerAdjust() {
      return false;
    },
    resetSubHeaderMarginMultiplier() {
      this.$store.commit("sub_header_margin_multiplier", 1);
    },
    setSubHeaderMarginMultiplier(multiplier) {
      this.$store.commit("sub_header_margin_multiplier", multiplier);
    },
    showTopHeader() {
      this.$("header").addClass("noElev");
      this.$(".header-top").removeClass("d-none");
    },
    hideTopHeader() {
      this.$("header").removeClass("noElev");
      this.$(".header-top").addClass("d-none");
    },
  },
  destroyed() {
    if (!this.bodyController.components.includes(this.$options.name))
      return false;

    this.detachBodyResizeListener();
  },
};

export default BodyController;
